import data from "../../.sourceflow/projects.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const projects_helper = new CollectionHelper(data);
